export default {
  loading: false,
  error: null,
  items: [],
};
